import React, { useEffect, useMemo, useState } from "react";
import { Modal, Typography, Space, Button } from "antd";

const { Text, Title } = Typography;

// Session cap (recommended). If you truly want it to be able to show repeatedly,
// set oncePerSession={false} when calling the hook.
const SESSION_KEY = "hms.promoNudge.sessionShown.v1";

function isWeekendNudgeDay(now = new Date()) {
  // JS: Sunday=0, Monday=1, ... Friday=5, Saturday=6
  const day = now.getDay();
  return day === 5 || day === 6 || day === 0; // Fri/Sat/Sun
}

function alreadyShownThisSession() {
  try {
    return sessionStorage.getItem(SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

function markShownThisSession() {
  try {
    sessionStorage.setItem(SESSION_KEY, "1");
  } catch {
    // ignore
  }
}

export const usePromotionNudge = ({
  enabled,
  showChance = 0.6,       // random probability (0..1)
  oncePerSession = true,  // prevents repeated popups while browsing
  weekendOnly = true,     // keep messaging aligned (“Friday/weekend”)
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    const now = new Date();

    if (weekendOnly && !isWeekendNudgeDay(now)) return;

    if (oncePerSession && alreadyShownThisSession()) return;

    // Random popup
    if (Math.random() > showChance) return;

    if (oncePerSession) markShownThisSession();

    setOpen(true);
  }, [enabled, showChance, oncePerSession, weekendOnly]);

  return {
    open,
    close: () => setOpen(false),
    show: () => setOpen(true),
  };
};

const PromotionNudgeModal = ({ open, onClose, onRunPromotion, displayName }) => {
  const greetingName = useMemo(() => {
    const n = String(displayName || "").trim();
    return n || "there";
  }, [displayName]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      title={<Title level={4} style={{ margin: 0 }}>Weekend Special</Title>}
    >
      <Space direction="vertical" size={10} style={{ width: "100%" }}>
        <Text>
          Hello <Text strong>{greetingName}</Text>. Today is Friday/weekend — do you want to run a promotion for your guest list?
        </Text>

        <Space style={{ marginTop: 6 }}>
          <Button onClick={onClose}>Not now</Button>
          <Button type="primary" onClick={onRunPromotion}>
            Yes, create promotion
          </Button>
        </Space>

        <Text type="secondary" style={{ fontSize: 12 }}>
          Select room type(s), start/end date, and generate a promotion code.
        </Text>
      </Space>
    </Modal>
  );
};

export default PromotionNudgeModal;
